import api from 'api'
import { INCOME_RECIEVED, INCOME_SAVED, INCOME_DELETED, INCOME_UNLOADED } from './types'

export const incomeSaved = data => ({
  type: INCOME_SAVED,
  data
})

export const incomeDataRecieved = data => ({
  type: INCOME_RECIEVED,
  data
})

export const incomeDeleted = data => ({
  type: INCOME_DELETED,
  data
})

export const incomeDataUnload = () => ({
  type: INCOME_UNLOADED
})

export const unloadIncomes = () => dispatch => {
  dispatch(incomeDataUnload())
}

export const deleteIncome = data => dispatch =>
  api.bmc.income.deleteIncome(data).then(()=>{
    dispatch(incomeDeleted(data))
  })

export const getIncomes = planid => dispatch =>
  api.bmc.income.getIncomes(planid).then(res => {
    dispatch(incomeDataRecieved(res))
  })

export const saveIncome = data => dispatch =>
  api.bmc.income.postIncome(data).then(res=> {
    dispatch(incomeSaved(res))
  })
